import type { CandidatePathway } from 'client/types.gen';

export const maxCandidateReferrers = 10;

export const allowedCandidatePathways = [
  'transition_services',
  'network_services',
  'concierge',
  'banff_access',
  'pro_bono',
] as const satisfies readonly CandidatePathway[];

export type AllowedCandidatePathway = (typeof allowedCandidatePathways)[number];

export const isAllowedCandidatePathway = (
  value: unknown,
): value is AllowedCandidatePathway =>
  allowedCandidatePathways.includes(value as AllowedCandidatePathway);
